import { AGENT_URL } from '../../config/env'
import type { DataSource, DataEntity, UploadResponse } from './types'

export async function uploadCSVFile(
  file: File,
  entity: DataEntity,
  source: DataSource,
  token: string,
  orgSlug?: string
): Promise<UploadResponse> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('entity', entity)
  formData.append('source', source)
  if (orgSlug) {
    formData.append('org_slug', orgSlug)
  }

  const response = await fetch(`${AGENT_URL}/data/process-file`, {
    method: 'POST',
    headers: {
      Authorization: token,
    },
    body: formData,
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(
      errorData.error ||
        errorData.message ||
        `Upload failed with status ${response.status}`
    )
  }

  return await response.json()
}
